import * as React from "react";
import PropTypes from "prop-types";

const IconMenu = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 24 24">
    <path
      fill={props.color ? props.color : "#000"}
      fillRule="evenodd"
      d="M19.75 12a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 .75-.75M19.75 7a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 .75-.75M19.75 17a.75.75 0 0 0-.75-.75H5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 .75-.75"
      clipRule="evenodd"
    ></path>
  </svg>
);

IconMenu.propTypes = {
  color: PropTypes.string,
};
export default IconMenu;
